import { axiosInstance as axios } from '../../boot/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // 取得付款資訊清單
    GetOrderPaymentList({ rootGetters }, request) {
      return axios
        .post('OrderPaymentInfo/GetOrderPaymentList', request)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetOrderPaymentByOrderID({ rootGetters }, request) {
      return axios
        .post('OrderPaymentInfo/GetOrderPaymentByOrderID', request)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    ConfirmRefusePayment({ rootGetters }, request) {
      return axios
        .post('OrderPaymentInfo/ConfirmRefusePayment', request)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddOrderPayment({ rootGetters }, request) {
      return axios
        .post('OrderPaymentInfo/AddOrderPayment', request)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    UpdateOrderPayment({ rootGetters }, request) {
      return axios
        .post('OrderPaymentInfo/UpdateOrderPayment', request)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 獲取預付款紀錄
    GetAdvancePaymentList({ rootGetters }, request) {
      return axios
        .post('OrderClient/GetAdvancePaymentList', {
          ...request
        })
        .then((response) => {
          if (response.data.Status) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject(response.data.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddAdvancePayment({ rootGetters }, request) {
      return axios
        .post('OrderClient/AddAdvancePayment', request)
        .then((response) => {
          if (response.data.Status) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject(response.data.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    UpdateAdvancePayment({ rootGetters }, request) {
      return axios
        .put('OrderClient/UpdateAdvancePayment', request)
        .then((response) => {
          if (response.data.Status) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject(response.data.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 更新客戶預付款確認狀態
    UpdateAdvancePaymentConfirm({ rootGetters }, request) {
      return axios
        .put('OrderClient/UpdateAdvancePaymentConfirm', { ...request })
        .then((response) => {
          if (response.data.Status) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject(response.data.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    ConfirmOrderPayment({ rootGetters }, request) {
      return axios
        .post('OrderPaymentInfo/ConfirmOrderPayment', request)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetDeductionRecordList({ rootGetters }, request) {
      return axios
        .post('OrderClient/GetDeductionRecordList', request)
        .then((response) => {
          if (response.data.Status) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject(response.data.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetNotOrderDeduction({ rootGetters }, request) {
      return axios
        .post('OrderClient/GetNotOrderDeduction', request)
        .then((response) => {
          if (response.data.Status) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject(response.data.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddOrderDeductionRecord({ rootGetters }, request) {
      return axios
        .post('OrderClient/AddOrderDeductionRecord', request)
        .then((response) => {
          if (response.data.Status) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject(response.data.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    UpdateOrderAmount({ rootGetters }, request) {
      return axios
        .post('OrderClient/UpdateOrderAmount', request)
        .then((response) => {
          return Promise.resolve(response.data)
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetStockOrderList({ commit, rootGetters }, request) {
      const formData = new FormData()
      formData.append('OemOrderId', request.OemOrderId)
      return axios
        .post('OemCaseTracking/GetStockOrderList', formData)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    }
  }
}
